export default [
  {
    path: '/referrals',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'referrals-list' */ '@/views/referrals/List.vue'),
  },
  {
    path: '/referrals/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'referrals-create' */ '@/views/referrals/Create.vue'),
  },
]
